import React from 'react'
import PropTypes from 'prop-types'

import { Dropdown } from 'semantic-ui-react'

import { AutoFocusSemanticUiComponent } from 'components/AutoFocusSemanticUiComponent'

export const AddRuleDropdown = ({ fields, onChange, onClose }) => (
  <AutoFocusSemanticUiComponent functionName="open" focus={fields.length > 0}>
    <Dropdown
      fluid
      multiple
      search
      selection
      placeholder={fields.length === 0 ? 'Loading...' : 'Customer data'}
      disabled={fields.length === 0}
      loading={fields.length === 0}
      options={fields.map((field, index) => {
        const value = getOptionValue(field)
        return {
          key: `${value}__${index}`,
          text: field.label,
          value,
          isCoreField: field.isCoreField,
        }
      })}
      onChange={(_, { value: [value] }) => {
        const field = fields.find((field) => getOptionValue(field) === value)
        const rule = {
          label: field.label,
          value: field.value,
          key: field.key,
          isCoreField: field.isCoreField,
          field_type: field.field_type,
        }
        onChange(rule)
      }}
      onClose={onClose}
    />
  </AutoFocusSemanticUiComponent>
)

AddRuleDropdown.propTypes = {
  fields: PropTypes.array,
  onChange: PropTypes.func.isRequired,
  onClose: PropTypes.func,
}

function getOptionValue(field) {
  return `${field.key}___${field.value}___${field.label}`
}



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/organisms/AudienceRuleGroup/AddRuleDropdown.js